'use client';

import { useSearchParams } from 'next/navigation';

const BOT_ID = process.env.NEXT_PUBLIC_BOT_ID || '';
const BOT_USERNAME = process.env.NEXT_PUBLIC_BOT_USERNAME || '';

export default function LoginClient() {
  const search = useSearchParams();
  const next = search.get('next') || '/';

  const origin =
    typeof window !== 'undefined' ? window.location.origin : 'https://console.skyvpn.org';

  // Telegram кидает auth-data в URL-фрагменте → return_to должен быть FRONTEND-страница,
  // которая прочитает #tgAuthResult и сделает POST на /api/v1/auth/telegram (JSON).
  const authUrl = `${origin}/login/callback?next=${encodeURIComponent(next)}`;
  const oauthUrl = BOT_ID
    ? `https://oauth.telegram.org/auth?bot_id=${encodeURIComponent(BOT_ID)}&origin=${encodeURIComponent(origin)}&request_access=write&return_to=${encodeURIComponent(authUrl)}`
    : '';

  return (
    <div className="min-h-screen flex items-center justify-center bg-app text-app p-4">
      <div className="w-full max-w-[420px]">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <span className="inline-flex h-10 w-10 rounded-lg items-center justify-center accent-bg text-white text-[16px] font-semibold">
            S
          </span>
          <span className="text-[18px] font-semibold tracking-tight">SkyVPN Console</span>
        </div>

        <div className="surface border border-app rounded-lg card-shadow p-8">
          <h1 className="text-[20px] font-semibold tracking-tight mb-2">Вход в админ-панель</h1>
          <p className="text-[13px] text-muted mb-6">
            Через Telegram. Доступ только аккаунтам из allow-list.
          </p>

          {!BOT_ID ? (
            <div className="text-[12px] text-[#F59E0B] border border-[#F59E0B]/30 rounded-lg p-3 mb-4">
              NEXT_PUBLIC_BOT_ID не задан.
            </div>
          ) : (
            <a
              href={oauthUrl}
              className="flex items-center justify-center gap-3 w-full h-12 rounded-lg bg-[#229ED9] text-white font-medium text-[14px] hover:opacity-90 ease-out-150 select-none"
            >
              <svg width="20" height="20" viewBox="0 0 240 240" fill="currentColor">
                <path d="M120 0C53.7 0 0 53.7 0 120s53.7 120 120 120 120-53.7 120-120S186.3 0 120 0zm55 82l-19 89c-1 4-5 5-9 3l-25-18-12 12c-2 2-3 3-6 3l2-30 56-51c2-2-1-3-3-2l-69 43-30-9c-4-1-4-4 1-6l116-44c3-1 6 1 5 5z" />
              </svg>
              Войти через Telegram
              {BOT_USERNAME && <span className="opacity-70 text-[12px]">@{BOT_USERNAME}</span>}
            </a>
          )}

          <div className="text-[11px] text-muted mt-6 leading-relaxed">
            После клика откроется страница Telegram, подтвердишь там — вернёшься сюда уже залогиненным. Cookie живёт 7 дней.
          </div>
        </div>
      </div>
    </div>
  );
}
